import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { Should_Cost_Workbench_Title } from 'src/constants/componentConstants/costModelling/skuShouldCostWorkbench'
import {
  validateFileUploadsync,
  fileUploadAsync,
} from 'src/services/costModelling/skuShouldCostWorkbench.services'

const baseInitialState = {
  file: {},
  fileError: [],
  data: [],
  loader: false,
  apiError: '',
  tab: 1, // 1 for upload and 2 for preview
  isValidationSuccessful: '',
  isUploadSuccessful: false,
}

// Function to create initial states
const createInitialState = (uploadType) => ({
  ...baseInitialState,
  upload: uploadType,
})

// Export initial states
const initialStateMap = {
  sku: createInitialState(Should_Cost_Workbench_Title?.Upload_Type.Sku),
  po: createInitialState(Should_Cost_Workbench_Title?.Upload_Type.Po),
  vendor: createInitialState(Should_Cost_Workbench_Title?.Upload_Type.Vendor),
}

export const uploadFileSlice = createSlice({
  name: 'upload',
  initialState: createInitialState(Should_Cost_Workbench_Title?.Upload_Type.Sku),
  reducers: {
    setUpload: (state, action) => {
      state.upload = action.payload
    },
    setFile: (state, action) => {
      state.file = action.payload
      state.fileError = []
      state.isValidationSuccessful = ''
      state.data = []
      state.apiError = ''
    },
    setTab: (state, action) => {
      state.tab = action.payload
    },
    reset: (state) => {
      return initialStateMap[state.upload]
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(validateFileUploadsync.pending), (state) => {
      state.loader = true
      state.isValidationSuccessful = ''
    })
    builder.addMatcher(isAnyOf(validateFileUploadsync.fulfilled), (state, action) => {
      state.loader = false
      state.data = action.payload.data
      if (action.payload.data.preview_data) {
        state.isValidationSuccessful = true
        state.tab = 2
      } else {
        state.isValidationSuccessful = false
      }
    })
    builder.addMatcher(isAnyOf(validateFileUploadsync.rejected), (state, action) => {
      state.loader = false
      state.apiError = action.payload.message
    })

    //file uploading
    builder.addMatcher(isAnyOf(fileUploadAsync.pending), (state) => {
      state.loader = true
    })
    builder.addMatcher(isAnyOf(fileUploadAsync.fulfilled), (state, action) => {
      state.loader = false
      state.isUploadSuccessful = true
    })
    builder.addMatcher(isAnyOf(fileUploadAsync.rejected), (state, action) => {
      state.loader = false
      state.apiError = action.payload.message
      state.isUploadSuccessful = false
    })
  },
})
export const {
  setUpload,
  setFile,
  setTab,
  reset,
} = uploadFileSlice.actions
export default uploadFileSlice.reducer
